module.exports = __webpack_public_path__ + "img/d72d445.png";